// Shared header slot — lets any page inject a right-side element (amount + action)
// into the global top Header bar.
import { createContext, useContext, useState, useEffect } from "react";

const Ctx = createContext({ extras: null, setExtras: () => {} });

export function HeaderExtrasProvider({ children }) {
  const [extras, setExtras] = useState(null);
  return <Ctx.Provider value={{ extras, setExtras }}>{children}</Ctx.Provider>;
}

export function useHeaderExtras() { return useContext(Ctx); }

// Hook: mount `node` into header on render, remove on unmount / deps change.
export function useHeaderExtrasEffect(node, deps = []) {
  const { setExtras } = useHeaderExtras();
  useEffect(() => {
    setExtras(node);
    return () => setExtras(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
